import { render, staticRenderFns } from "./subsActivePercential.vue?vue&type=template&id=bbabee14&scoped=true"
import script from "./subsActivePercential.vue?vue&type=script&lang=js"
export * from "./subsActivePercential.vue?vue&type=script&lang=js"
import style0 from "./subsActivePercential.vue?vue&type=style&index=0&id=bbabee14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbabee14",
  null
  
)

export default component.exports